import trim from 'lodash/trim';
import { addProtocol } from '../addProtocol';
import type { Validator } from './types';

const AVAILABLE_PROTOCOLS = ['http:', 'https:'];

export function makeUrlValidator(): Validator<string> {
    return (value?: string) => {
        if (!value) {
            return undefined;
        }
        const maybeUrl = addProtocol(trim(value));

        if (!maybeUrl) {
            return undefined;
        }

        if (/\s+/.test(value || '')) {
            return 'Ссылка не может содержать пробельных символов';
        }

        try {
            const url = new URL(maybeUrl);

            if (!AVAILABLE_PROTOCOLS.includes(url.protocol)) {
                return 'Неподдерживаемые протокол';
            }

            const isValidQuery = url.search.slice(1).indexOf('?') === -1;

            if (!isValidQuery) {
                return 'Неверный формат query параметров';
            }

            const hasForbiddenQuery = url.searchParams.get('utm_source') !== null;

            if (hasForbiddenQuery) {
                return 'URL не должен содержать utm_source, тк сервис проставляет данную метку самостоятельно.';
            }

            return undefined;
        } catch (error) {
            return 'Некорректный URL';
        }
    };
}
